export default function () {
    const match = window.location.host.match(/(.*?)(-[^.]*)?[.](.*)/);
    return {
        vhost: match && match[1] ? match[1] : '',
        stage: match && match[2] ? match[2] : '',
        domain: match && match[3] ? match[3] : '',
    };
}
